import { render, staticRenderFns } from "./CloudItemClassDept.vue?vue&type=template&id=70bbc292&"
import script from "./CloudItemClassDept.vue?vue&type=script&lang=js&"
export * from "./CloudItemClassDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports